<div class="window-negation window">
  <ng-container *ngIf="inConversation()">
    <div class="banner">
      <div class="banner-container">
        <div class="banner-wrapper">
          <svg
            class="banner-icon"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="20" cy="20" r="20" fill="#B0D3D9" />
            <svg
              x="8"
              y="8"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.67409 4.65983L10.3642 6.57115C11.1307 8.69246 12.8057 10.3629 14.9327 11.1275L16.8491 11.8157C17.0218 11.8783 17.0218 12.1226 16.8491 12.1843L14.9327 12.8725C12.8057 13.637 11.1307 15.3075 10.3642 17.4288L9.67409 19.3402C9.61135 19.5124 9.36643 19.5124 9.30455 19.3402L8.61447 17.4288C7.8479 15.3075 6.17296 13.637 4.04598 12.8725L2.12955 12.1843C1.95682 12.1217 1.95682 11.8774 2.12955 11.8157L4.04598 11.1275C6.17296 10.3629 7.8479 8.69246 8.61447 6.57115L9.30455 4.65983C9.36643 4.48669 9.61135 4.48669 9.67409 4.65983Z"
                fill="white"
              />
              <path
                d="M18.3008 0.0662106L18.6505 1.03387C19.039 2.10781 19.8872 2.95376 20.964 3.34117L21.9343 3.69001C22.0219 3.72172 22.0219 3.84514 21.9343 3.87686L20.964 4.22569C19.8872 4.6131 19.039 5.45905 18.6505 6.53299L18.3008 7.50066C18.269 7.58808 18.1452 7.58808 18.1134 7.50066L17.7637 6.53299C17.3752 5.45905 16.527 4.6131 15.4502 4.22569L14.48 3.87686C14.3923 3.84514 14.3923 3.72172 14.48 3.69001L15.4502 3.34117C16.527 2.95376 17.3752 2.10781 17.7637 1.03387L18.1134 0.0662106C18.1452 -0.0220702 18.2698 -0.0220702 18.3008 0.0662106Z"
                fill="white"
              />
              <path
                d="M18.3008 16.5L18.6505 17.4676C19.039 18.5416 19.8872 19.3875 20.964 19.775L21.9343 20.1238C22.0219 20.1555 22.0219 20.2789 21.9343 20.3106L20.964 20.6595C19.8872 21.0469 19.039 21.8928 18.6505 22.9668L18.3008 23.9344C18.269 24.0219 18.1452 24.0219 18.1134 23.9344L17.7637 22.9668C17.3752 21.8928 16.527 21.0469 15.4502 20.6595L14.48 20.3106C14.3923 20.2789 14.3923 20.1555 14.48 20.1238L15.4502 19.775C16.527 19.3875 17.3752 18.5416 17.7637 17.4676L18.1134 16.5C18.1452 16.4126 18.2698 16.4126 18.3008 16.5Z"
                fill="white"
              />
            </svg>
          </svg>
          <div
            class="banner-text"
            (click)="resetConversation()"
            (keydown.enter)="resetConversation()"
            tabindex="0"
            role="button"
          >
            <h1 class="banner-title">{{ 'habaProductAdvisor.title' | cxTranslate }}</h1>
            <h2 class="banner-powered-by">{{ 'habaProductAdvisor.bannerTitle' | cxTranslate }}</h2>
          </div>
          <div class="banner-btn-download">
            <svg
              width="21"
              height="22"
              viewBox="0 0 21 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.97796 16.1227C10.1145 16.1793 10.2642 16.2105 10.4212 16.2105C10.7175 16.2105 11.0138 16.0975 11.2399 15.8714L17.0294 10.0819C17.4816 9.62973 17.4816 8.89659 17.0294 8.4444C16.5772 7.99222 15.8441 7.99222 15.3919 8.4444L11.5791 12.2572L11.5791 1.15789C11.5791 0.518405 11.0607 0 10.4212 0C9.7817 0 9.26329 0.518405 9.26329 1.15789L9.26329 12.2572L5.45046 8.4444C4.99828 7.99222 4.26514 7.99222 3.81296 8.4444C3.36077 8.89659 3.36077 9.62973 3.81295 10.0819L9.60243 15.8714C9.71344 15.9824 9.84139 16.0662 9.97796 16.1227Z"
                fill="white"
              />
              <path
                d="M2.31579 16.2105C2.31579 15.571 1.79738 15.0526 1.15789 15.0526C0.518407 15.0526 0 15.571 0 16.2105V18.5263C0 19.4476 0.365976 20.3311 1.01742 20.9826C1.66886 21.634 2.55241 22 3.47368 22H17.3684C18.2897 22 19.1732 21.634 19.8247 20.9826C20.4761 20.3311 20.8421 19.4476 20.8421 18.5263V16.2105C20.8421 15.571 20.3237 15.0526 19.6842 15.0526C19.0447 15.0526 18.5263 15.571 18.5263 16.2105V18.5263C18.5263 18.8334 18.4043 19.1279 18.1872 19.345C17.97 19.5622 17.6755 19.6842 17.3684 19.6842H3.47368C3.16659 19.6842 2.87208 19.5622 2.65493 19.345C2.43778 19.1279 2.31579 18.8334 2.31579 18.5263V16.2105Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="content" [class.content-in-conversation]="inConversation()">
    <ng-container *ngIf="!inConversation()">
      <div class="header">
        <svg
          class="header-svg"
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="40" cy="40" r="40" fill="#B0D3D9" />
          <svg
            x="16"
            y="16"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.3482 9.31965L20.7283 13.1423C22.2615 17.3849 25.6114 20.7259 29.8653 22.2549L33.6982 23.6314C34.0437 23.7566 34.0437 24.2451 33.6982 24.3685L29.8653 25.745C25.6114 27.2741 22.2615 30.615 20.7283 34.8577L19.3482 38.6803C19.2227 39.0249 18.7329 39.0249 18.6091 38.6803L17.2289 34.8577C15.6958 30.615 12.3459 27.2741 8.09196 25.745L4.2591 24.3685C3.91363 24.2434 3.91363 23.7548 4.2591 23.6314L8.09196 22.2549C12.3459 20.7259 15.6958 17.3849 17.2289 13.1423L18.6091 9.31965C18.7329 8.97339 19.2227 8.97339 19.3482 9.31965Z"
              fill="white"
            />
            <path
              d="M36.6016 0.132421L37.3011 2.06774C38.078 4.21562 39.7744 5.90753 41.928 6.68234L43.8685 7.38002C44.0438 7.44344 44.0438 7.69029 43.8685 7.75371L41.928 8.45139C39.7744 9.2262 38.078 10.9181 37.3011 13.066L36.6016 15.0013C36.538 15.1762 36.2905 15.1762 36.2269 15.0013L35.5273 13.066C34.7504 10.9181 33.054 9.2262 30.9004 8.45139L28.9599 7.75371C28.7846 7.69029 28.7846 7.44344 28.9599 7.38002L30.9004 6.68234C33.054 5.90753 34.7504 4.21562 35.5273 2.06774L36.2269 0.132421C36.2905 -0.0441404 36.5397 -0.0441404 36.6016 0.132421Z"
              fill="white"
            />
            <path
              d="M36.6016 33L37.3011 34.9353C38.078 37.0832 39.7744 38.7751 41.928 39.5499L43.8685 40.2476C44.0438 40.311 44.0438 40.5578 43.8685 40.6213L41.928 41.3189C39.7744 42.0938 38.078 43.7857 37.3011 45.9336L36.6016 47.8689C36.538 48.0437 36.2905 48.0437 36.2269 47.8689L35.5273 45.9336C34.7504 43.7857 33.054 42.0938 30.9004 41.3189L28.9599 40.6213C28.7846 40.5578 28.7846 40.311 28.9599 40.2476L30.9004 39.5499C33.054 38.7751 34.7504 37.0832 35.5273 34.9353L36.2269 33C36.2905 32.8251 36.5397 32.8251 36.6016 33Z"
              fill="white"
            />
          </svg>
        </svg>

        <div class="title-container">
          <h1>
            {{ 'habaProductAdvisor.welcome.greetings' | cxTranslate }}
            <span class="title-highlight">{{
              'habaProductAdvisor.welcome.name' | cxTranslate
            }}</span>
          </h1>
          <span class="title-welcome-message"
            >{{ 'habaProductAdvisor.welcome.message' | cxTranslate }}
          </span>
        </div>
      </div>
      <div class="description-container">
        <div class="description-text">
          <span>
            {{ 'habaProductAdvisor.welcome.description' | cxTranslate }}
          </span>
        </div>
        <div class="description-template-questions">
          <ng-container
            *ngIf="'habaProductAdvisor.chat.templateQuestions.question1' | cxTranslate as question"
          >
            <div
              class="description-phrase description-phrase-border"
              (click)="sendMessage($event, question)"
              (keydown.enter)="sendMessage($event, question)"
              tabindex="0"
              role="button"
            >
              <span>{{ question }}</span>
            </div>
          </ng-container>
          <ng-container
            *ngIf="'habaProductAdvisor.chat.templateQuestions.question2' | cxTranslate as question"
          >
            <div
              class="description-phrase description-phrase-border"
              (click)="sendMessage($event, question)"
              (keydown.enter)="sendMessage($event, question)"
              tabindex="0"
              role="button"
            >
              <span>{{ question }}</span>
            </div>
          </ng-container>
          <ng-container
            *ngIf="'habaProductAdvisor.chat.templateQuestions.question3' | cxTranslate as question"
          >
            <div
              class="description-phrase description-phrase-border"
              (click)="sendMessage($event, question)"
              (keydown.enter)="sendMessage($event, question)"
              tabindex="0"
              role="button"
            >
              <span>{{ question }}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="inConversation()">
      <div class="chat-history">
        <app-chat-message
          *ngFor="let msg of messages"
          [message]="msg"
          class="messages"
        ></app-chat-message>
        <app-product-advisor-products-list
          [productRecommendations]="productRecommendations"
        ></app-product-advisor-products-list>
        <app-chat-message
          *ngIf="isSendingNewMessage"
          [message]="loadingMessage"
          [isLoading]="true"
          class="messages"
        ></app-chat-message>
      </div>
      <div class="recommendation-message-container">
        <div
          class="recommendation-message"
          (click)="onShowContactFormClick()"
          (keydown.enter)="onShowContactFormClick()"
          tabindex="0"
          role="button"
        >
          <span class="recommendation-message-text">{{
            'habaProductAdvisor.recommendations.callContactForm' | cxTranslate
          }}</span>
        </div>
      </div>
    </ng-container>
    <div class="chat-container" [class.chat-container-active]="inConversation()">
      <form class="chat chat-ui" (submit)="$event.preventDefault(); sendMessage($event)">
        <div class="chat-dim">
          <label for="chat-dimension-length">{{
            'habaProductAdvisor.chat.dimension.length' | cxTranslate
          }}</label>
          <input
            type="number"
            [value]="getRoomDimensions()[0]"
            #roomLength
            id="chat-dimension-length"
            class="chat-input"
            (input)="setRoomLength(roomLength.value)"
          />
        </div>
        <div class="chat-dim">
          <label for="chat-dimension-width">{{
            'habaProductAdvisor.chat.dimension.width' | cxTranslate
          }}</label>
          <input
            type="number"
            [value]="getRoomDimensions()[1]"
            #roomWidth
            id="chat-dimension-width"
            class="chat-input"
            (input)="setRoomWidth(roomWidth.value)"
          />
        </div>
        <div class="chat-message">
          <label for="chat-message">{{
            'habaProductAdvisor.chat.yourMessage' | cxTranslate
          }}</label>
          <input type="text" #chatMessage id="chat-message" class="chat-input" />
        </div>
        <input type="submit" value="" class="chat-submit" />
      </form>
    </div>
    <div class="disclaimer" *ngIf="!inConversation()">
      <span>{{ 'habaProductAdvisor.chat.legalText' | cxTranslate }}</span>
    </div>
    <div #chatBottom></div>
  </div>
  <ng-container *ngIf="inConversation()">
    <div class="btn-download">
      <div
        class="btn-download-content"
        (click)="exportChatToExcel()"
        (keydown.enter)="exportChatToExcel()"
        tabindex="0"
        role="button"
      >
        <div class="btn-download-icon">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_2447_239804)">
              <path
                d="M10.5568 16.1227C10.6933 16.1793 10.843 16.2105 11 16.2105C11.2964 16.2105 11.5927 16.0975 11.8188 15.8714L17.6083 10.0819C18.0605 9.62973 18.0605 8.89659 17.6083 8.4444C17.1561 7.99222 16.4229 7.99222 15.9708 8.4444L12.1579 12.2572L12.1579 1.15789C12.1579 0.518405 11.6395 0 11 0C10.3606 0 9.84215 0.518405 9.84215 1.15789L9.84214 12.2572L6.02932 8.4444C5.57714 7.99222 4.844 7.99222 4.39181 8.4444C3.93963 8.89659 3.93963 9.62973 4.39181 10.0819L10.1813 15.8714C10.2923 15.9824 10.4202 16.0662 10.5568 16.1227Z"
                fill="#00555A"
              />
              <path
                d="M2.89465 16.2105C2.89465 15.571 2.37624 15.0526 1.73675 15.0526C1.09726 15.0526 0.578857 15.571 0.578857 16.2105V18.5263C0.578857 19.4476 0.944834 20.3311 1.59628 20.9826C2.24772 21.634 3.13126 22 4.05254 22H17.9473C18.8686 22 19.7521 21.634 20.4035 20.9826C21.055 20.3311 21.421 19.4476 21.421 18.5263V16.2105C21.421 15.571 20.9026 15.0526 20.2631 15.0526C19.6236 15.0526 19.1052 15.571 19.1052 16.2105V18.5263C19.1052 18.8334 18.9832 19.1279 18.766 19.345C18.5489 19.5622 18.2544 19.6842 17.9473 19.6842H4.05254C3.74545 19.6842 3.45093 19.5622 3.23379 19.345C3.01664 19.1279 2.89465 18.8334 2.89465 18.5263V16.2105Z"
                fill="#00555A"
              />
            </g>
            <defs>
              <clipPath id="clip0_2447_239804">
                <rect width="22" height="22" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <span class="btn-download-text">
          {{ 'habaProductAdvisor.chat.saveHistory' | cxTranslate }}
        </span>
      </div>
    </div>
  </ng-container>
</div>
